
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="200" height="200" class="icon" viewBox="0 0 1024 1024"><path d="M893.775 323c-149.4-265-587.6-323-587.6-323s202.2 220.8-56.2 395.4c-163.4 110.2-228 253.4-158 409.8 53.6 119.8 167 168.6 289.2 186.8-58.4-110.2-13.2-244.8-8.2-259.2 114.2 172.8 330 0 221.6-187.8 142 30.8 163.2 277.2 54.2 431 161-50.6 268.2-177.8 297.6-291.2 31-118.6 7.4-255.8-52.6-361.8z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    